module.exports = __webpack_public_path__ + "static/media/icons_remision.c2f10404.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons_remision.svg
// module id = 1129
// module chunks = 0